/** @jsxRuntime classic */
/** @jsx jsx */
import { jsx } from "@emotion/react";
import React from "react";
import type { DayContent, StageContent, Video } from "@spwn/types";
import { EventTimetableCartButton } from "./EventTimetableCartButton";
import { EventTimetablePlayButton } from "./EventTimetablePlayButton";

type DayAndStageActionStatus =
  | StageContent["actionStatus"]
  | DayContent["actionStatus"];

export const EventTimetableVideoButton = (props: {
  actionStatus: Video["actionStatus"];
  doVideoButtonAction: () => void;
}) => {
  switch (props.actionStatus) {
    case "NotAvailableForPurchase":
      return (
        <EventTimetableCartButton disabled={true}>
          SINGLE チケットを購入
        </EventTimetableCartButton>
      );

    case "NotPurchased":
      return (
        <EventTimetableCartButton onClick={props.doVideoButtonAction}>
          SINGLE チケットを購入
        </EventTimetableCartButton>
      );

    case "InCart":
      return (
        <EventTimetableCartButton
          onClick={props.doVideoButtonAction}
          variant="outlined"
          badge={true}
        >
          カートを確認する
        </EventTimetableCartButton>
      );

    case "Playable":
      return (
        <EventTimetablePlayButton onClick={props.doVideoButtonAction}>
          ライブを視聴
        </EventTimetablePlayButton>
      );

    case "BeforePlay":
      return (
        <EventTimetablePlayButton
          onClick={props.doVideoButtonAction}
          disabled={true}
        >
          ライブを待機中
        </EventTimetablePlayButton>
      );

    case "NotPlayable":
    default:
      return null;
  }
};

export const EventTimetableDayAndStageButton = (props: {
  name: string;
  actionStatus: DayAndStageActionStatus;
  doButtonAction: () => void;
}) => {
  switch (props.actionStatus) {
    case "NotAvailableForPurchase":
      return (
        <EventTimetableCartButton disabled={true}>
          {`${props.name}チケットを購入`}
        </EventTimetableCartButton>
      );

    case "NotPurchased":
      return (
        <EventTimetableCartButton onClick={props.doButtonAction}>
          {`${props.name}チケットを購入`}
        </EventTimetableCartButton>
      );

    case "InCart":
      return (
        <EventTimetableCartButton
          onClick={props.doButtonAction}
          variant="outlined"
          badge={true}
        >
          {`${props.name}チケットのカートを確認する`}
        </EventTimetableCartButton>
      );

    case "SettlementConfirm":
      return (
        <EventTimetableCartButton onClick={props.doButtonAction}>
          {`${props.name}チケットの支払状況を確認`}
        </EventTimetableCartButton>
      );

    case "Purchased":
    case "BeforePlay": // ステージのみ。ポップアップでは購入済みとする
    case "Playable": // ステージのみ。ポップアップでは購入済みとする
      return (
        <EventTimetableCartButton disabled={true}>
          {`${props.name}チケット購入済み`}
        </EventTimetableCartButton>
      );

    default:
      return null;
  }
};
